import React, { FunctionComponent } from "react";
import MaskedInput from "react-text-mask";
import { InputProps, inputStyle } from "Shared/Form/Input";
import styled from "styled-components";

const Input: FunctionComponent<InputProps> = (props) => {
    const { error, hasError, hasLabel, ...rest } = props;

    return (
        <MaskedInput
            {...rest}
            guide={false}
            mask={["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
            placeholder="(___) ___-____"
        />
    );
};

const PhoneInput = styled(Input)<any>`
    ${inputStyle};
`;

export default PhoneInput;
